import React, { useEffect, useState } from 'react';
import {
    notification,
    Select,
    Skeleton,
    Typography,
} from 'antd';

import { useTranslation } from 'react-i18next';
import { AuthConsumer } from 'shared/contexts/AuthContext';
import {Link, useHistory} from 'react-router-dom';
import API_SERVICE from 'shared/services/api-service';
import moment from 'moment';
import Text from 'antd/es/typography/Text';
import FrontendSidebar from 'views/FrontendSidebar/FrontendSidebar';
import activeBadge from '../../../src/img/active-badge.png';
import inactiveBadge from '../../../src/img/inactive-badge.png';

// import 'jquery/dist/jquery.min.js';
import "datatables.net-dt/js/dataTables.dataTables"
import "datatables.net-dt/css/jquery.dataTables.min.css"


const { Option } = Select;

interface Props {
    location: any;
}

const { Title } = Typography;
export default function InsCourseReport(props: Props) {
    const { t } = useTranslation();
  const history = useHistory();
  const user = JSON.parse(localStorage.getItem('auth-token') as string)?.user;
    return (
        <div className={'profile-wrapper container-fluid pl-0 pr-0'}>
            <AuthConsumer>
                {({ isAuth, updateUser, cartTime, cart, user }) => (
                    <>
                    <div className='d-md-flex'>
                        
                        <FrontendSidebar menuSelect={7} />
                        
                        <div className={'profile-tab-content-div pl-3 pr-3 mb-3'} style={{width: '100%'}}>
                        <div className='insCourseReport'>
                            <CourseReport />
                        </div>
                        </div>
                    </div>
                    </>
                )}
            </AuthConsumer>
        </div>
    );
}
function CourseReport() {
    const { t } = useTranslation();
    const history = useHistory();
    const [items, setItems] = useState([] as any[]);
    const [fetching, setFetching] = useState(false as boolean);
    useEffect(() => {
        setFetching(true);
        API_SERVICE.insCourseReport().then(({ data: { data: { items } } }) => {
            setItems(items);
            var $ = require('jquery')
            $(document).ready(function () {
                // setTimeout(function(){
                $('#insCourseReportList').DataTable();
                // } ,1000);
            });
            setFetching(false);
        }).catch((e: any) => {
            setFetching(false);
            notification.error({ message: t(API_SERVICE.handleErrors(e)) });
        });
    }, []);


    if(fetching){
        return <Skeleton active={true} />
    }
    return <div>
        <div className='bg-white p-3 br-5px mt-3'>
            <div className="row">
            <div className="col-md-12 pb-3">
                <div className="table-responsive table-br-5 box-shadow mt-2">
                    <table id='insCourseReportList' className="table table-meetings table-report">
                        <thead>
                            <tr>
                            <th className="text-uppercase text-secondary">Course</th>
                            <th className="text-uppercase text-secondary">Category</th>
                            <th className="text-uppercase text-secondary text-center">
                                Course Content
                                <table className='table'>
                                    <tr>
                                        <th className="text-uppercase text-secondary">video</th>
                                        <th className="text-uppercase text-secondary">pdf</th>
                                        <th className="text-uppercase text-secondary">ppt</th>
                                        <th className="text-uppercase text-secondary">quiz</th>
                                    </tr>
                                </table>
                            </th>
                            <th className="text-uppercase text-secondary text-center">Enrolled Students</th>
                            <th className="text-uppercase text-secondary text-center">status</th>
                            <th className="text-uppercase text-secondary text-center">Created at</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                items && items.map(item => {
                                    //console.log(item);
                                    return <tr>
                                        <td>
                                            <div className="d-flex align-items-center">
                                                {/* <div className="mr-3">
                                                    <img src={deFlag} className="uploaded-img-cat" height="40" width="40"/>
                                                </div> */}
                                                <div className="">
                                                    <p className="mb-0"><span>{item?.title}</span></p>
                                                </div>
                                            </div>
                                        </td>
                                        <td className="text-secondary">{item?.category?.name}</td>
                                        <td className="text-secondary">
                                        <table className='table'>
                                            <tr>
                                                <td className="text-uppercase text-secondary text-center">{item?.lecture_count}</td>
                                                <td className="text-uppercase text-secondary text-center">{item?.pdf_count}</td>
                                                <td className="text-uppercase text-secondary text-center">{item?.ppt_count}</td>
                                                <td className="text-uppercase text-secondary text-center">{item?.quiz_count}</td>
                                            </tr>
                                        </table>
                                        </td>
                                        <td className="text-secondary text-center">
                                            <span role={item?.courses_purchased_count == 0 ? '' : 'button'} className={item?.courses_purchased_count == 0 ? 'text-secondary' : 'text-blue'} onClick={() => {
                                                if(item.courses_purchased_count != 0){
                                                    history.push(`/my/management/course-student/${item?.id}`)
                                                }
                                            }}>
                                                {item?.courses_purchased_count}
                                            </span>
                                        </td>
                                        <td className="text-center">
                                            {item.status === 'ACTIVE' ? <img src={activeBadge}/> : <img src={inactiveBadge}/>}
                                        </td>
                                        <td className="text-secondary">{moment(item?.created_at).format('DD MMMM, YYYY')}</td>
                                    </tr>
                                })
                            }
                        </tbody>
                    </table>
                </div>
            </div>
            </div>
        </div>
    </div>;
}
